import React, { useEffect, useState } from "react";
import { Table, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import { API_URI } from "../Common/data";
import { toast } from "react-toastify";

const UserQueries = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);

  const formatDate = (date) => new Date(date).toLocaleDateString();

  const shortenText = (text, limit = 120) => {
    if (!text) return "";
    return text.length > limit ? `${text.slice(0, limit).trim()}...` : text;
  };

  useEffect(() => {
    const fetchQueries = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URI}/queries/user/self`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("cine_userToken")}`
          }
        });
        setQueries(response.data.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error.response?.data?.message || "Failed to fetch queries!");
      }
    };

    fetchQueries();
  }, []);

  return (
    <>
      <div className="profile-query-table__header">
        <div>
          <p className="profile-kicker mb-2">Support Desk</p>
          <h4 className="mb-0">My Queries</h4>
        </div>
      </div>
      {loading ? (
        <div className="profile-query-table__loading">
          <Spinner animation="border" />
        </div>
      ) : queries.length === 0 ? (
        <Alert variant="info" className="profile-query-table__empty">
          No queries found.
        </Alert>
      ) : (
        <>
          <div className="profile-query-table">
            <Table className="qurey-table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Subject</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Raised At</th>
                </tr>
              </thead>
              <tbody>
                {queries.map((query, index) => (
                  <tr key={query._id}>
                    <td>{index + 1}</td>
                    <td className="profile-query-table__subject">
                      {query.subject}
                    </td>
                    <td>{shortenText(query?.description, 100)}</td>
                    <td>
                      <span
                        className={`profile-query-status ${
                          query.status === "resolved"
                            ? "is-resolved"
                            : "is-pending"
                        }`}
                      >
                        {query.status}
                      </span>
                    </td>
                    <td>{formatDate(query.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="profile-query-cards">
            {queries.map((query, index) => (
              <article className="profile-query-card" key={query._id}>
                <div className="profile-query-card__top">
                  <span className="profile-query-card__index">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`profile-query-status ${
                      query.status === "resolved"
                        ? "is-resolved"
                        : "is-pending"
                    }`}
                  >
                    {query.status}
                  </span>
                </div>

                <div className="profile-query-card__body">
                  <p className="profile-kicker mb-2">Subject</p>
                  <h5 className="profile-query-table__subject mb-2">
                    {query.subject}
                  </h5>
                  <p className="profile-query-card__description mb-0">
                    {shortenText(query?.description)}
                  </p>
                </div>

                <div className="profile-query-card__footer">
                  <span>Raised on</span>
                  <strong>{formatDate(query.createdAt)}</strong>
                </div>
              </article>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default UserQueries;
